<template>
  <v-dialog v-model="visible" scrollable max-width="600px">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ $t('toolbar-title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pt-4">
        <div v-if="$autocompletion.get('domains').length === 0">
          {{ $t('empty-domain') }}
        </div>
        <v-row v-else>
          <v-col cols="12">
            <v-btn @click="remove()" text>
              <v-icon left>mdi-delete</v-icon>
              {{ $t('actions.remove-all') }}
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left"> {{ $t('name') }}</th>
                  <th class="text-right"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="domain in $autocompletion.get('domains')" :key="domain">
                  <td class="text-left">{{ domain }}</td>
                  <td class="text-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small icon color="warning" @click="remove(domain)" v-bind="attrs" v-on="on">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('remove-web-site') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DomainCompletionDialog',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    remove (value) {
      if (value) this.$autocompletion.remove('domains', value)
      else this.$autocompletion.purge('domains')
    },
  },
  mounted () {
    this.$bus.on('dialog/domain_completion/open', () => {
      this.visible = true
    })
  }
}
</script>

<i18n>
{
	"en": {
		"empty-domain": "You do not have any domain names stored.",
		"name": "Name",
		"remove-web-site": "Delete the website",
		"toolbar-title": "Memorized websites"
	},
	"es": {
		"empty-domain": "No tiene ningún nombre de dominio almacenado.",
		"name": "Apellido",
		"remove-web-site": "Eliminar el sitio web",
		"toolbar-title": "Páginas web memorizadas"
	},
	"fr": {
		"empty-domain": "Vous n'avez pas de noms de domaines mémorisés.",
		"name": "Nom",
		"remove-web-site": "Supprimer le site web",
		"toolbar-title": "Sites web mémorisés"
	},
	"it": {
		"empty-domain": "Non hai nomi di dominio memorizzati.",
		"name": "Nome",
		"remove-web-site": "Elimina il sito web",
		"toolbar-title": "Siti web memorizzati"
	},
	"pt": {
		"empty-domain": "Não tem nenhum nome de domínio guardado.",
		"name": "Nome",
		"remove-web-site": "Eliminar o site",
		"toolbar-title": "Sites memorizados"
	},
	"pl": {
		"empty-domain": "Nie masz żadnych zapamiętanych nazw domen.",
		"name": "Nazwa",
		"remove-web-site": "Usuń stronę internetową",
		"toolbar-title": "Zapamiętane strony internetowe"
	}
}
</i18n>
